module.exports = __webpack_public_path__ + "img/8121.f9449c7f.jpg";